import { Component, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-summary-item',
  templateUrl: './summary-item.component.html',
  styleUrls: [ './summary-item.component.scss' ],
  imports: [
    NgbTooltip
  ]
})
export class SummaryItemComponent {
  icon = input.required<string>();
  iconBgColor = input<string | undefined>(undefined);
  tooltipText = input<string>();
}